// extracted by mini-css-extract-plugin
export default {"error":"LoginSignup_error__YKLEL","form":"LoginSignup_form__s2f+P"};